/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types'; /* eslint-disable-line no-unused-vars */

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

import styled from 'styled-components';

import { asField } from 'informed';
import { get, round } from 'lodash-es';

import NumberFormat from './PercentNumberFormatComponent';
import HtmlTooltip from './HtmlTooltip';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class NumberFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  // workaround to prevent an issue of react-number-format with decimalSeparator: ','
  handleChange = e => {
    const { fieldApi, onChange, ratio } = this.props;
    const value = get(e, 'target.value');
    const ratedValue = value === 0 ? 0 : round(value / ratio, 4);

    if (fieldApi.setValue) fieldApi.setValue(ratedValue);

    if (onChange) {
      onChange(ratedValue);
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    const { setTouched } = fieldApi;
    const {
      classes,
      onChange,
      onBlur,
      field,
      defaultValue,
      multiple,
      shrink,
      label = '',
      //   name = "default_name",
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      forwardedRef,
      tooltip = '',
      ratio,
      ...rest
    } = props;
    const percentValue = round(value * ratio, 2);

    return (
      <>
        {tooltip && (
          <HtmlTooltip title={tooltip}>
            <span className="helper">?</span>
          </HtmlTooltip>
        )}
        <StyledFormControl error={!!fieldState.error}>
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            name={field}
            label={label}
            defaultValue={defaultValue}
            ref={this.selectRef}
            value={percentValue}
            InputLabelProps={{ shrink }}
            onChange={this.handleChange}
            onBlur={e => {
              setTouched();
              if (onBlur) {
                onBlur(e);
              }
            }}
            // material-ui props
            InputProps={{
              inputComponent: NumberFormat,
              id,
            }}
            prefix="%"
          />
          <FormHelperText>{fieldState.error || helperText}</FormHelperText>
        </StyledFormControl>
      </>
    );
  }
}

NumberFieldComponent.propTypes = {
  ratio: PropTypes.number,
  tooltip: PropTypes.string,
};

NumberFieldComponent.defaultProps = {
  ratio: 100,
};

export default asField(NumberFieldComponent);
